import * as React from 'react';
import { useGridSelector } from '@mui/x-data-grid-pro';
import { gridPivotPanelOpenSelector } from '@mui/x-data-grid-pro/internals';
import { useGridRootProps } from "../hooks/utils/useGridRootProps.js";
import { useGridApiContext } from "../hooks/utils/useGridApiContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function GridColumnMenuPivotItem(props) {
  const {
    onClick
  } = props;
  const rootProps = useGridRootProps();
  const apiRef = useGridApiContext();
  const isPivotPanelOpen = useGridSelector(apiRef, gridPivotPanelOpenSelector);
  const openPivotSettings = event => {
    onClick(event);
    apiRef.current.setPivotPanelOpen(true);
  };
  return /*#__PURE__*/_jsx(rootProps.slots.baseMenuItem, {
    onClick: openPivotSettings,
    iconStart: /*#__PURE__*/_jsx(rootProps.slots.pivotIcon, {
      fontSize: "small"
    }),
    disabled: isPivotPanelOpen,
    children: apiRef.current.getLocaleText('columnMenuManagePivot')
  });
}